export default [
  {
    title: 'Mobile App Users',
    icon: 'UsersIcon',
    route: 'clientmanagement',
  },
  {
    title: 'Admin Users',
    icon: 'ShieldIcon',
    route: 'admin-users-management',
  },
  {
    title: 'Advertisers Management',
    icon: 'BriefcaseIcon',
    route: 'advertisers-management',
  },
  {
    title: 'Ads Management',
    icon: 'MonitorIcon',
    route: 'ads-video-management',
  },
  {
    title: 'Categories',
    icon: 'GridIcon',
    route: 'categories-management',
  },
  {
    title: 'Brands',
    icon: 'AwardIcon',
    route: 'brands-management',
  },
  {
    title: 'Reports',
    icon: 'PieChartIcon',
    route: 'project-planning',
  },
  {
    title: 'CMS',
    icon: 'FileTextIcon',
    route: 'cms',
  },
  {
    title: 'Plans',
    icon: 'CreditCardIcon',
    route: 'pages-pricing',
  },
  {
    title: 'Setup',
    icon: 'SettingsIcon',
    route: 'setup',
  },
]
